// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f

export const COMMENT = 'COMMENT';
export const COMPOSITION = 'COMPOSITION';
export const EMAIL_COMPOSITION = 'EMAIL_COMPOSITION';
export const REPLY = 'REPLY';
export const FORWARD = 'FORWARD';
export const DIRECT_REPLY = 'DIRECT_REPLY';